import type { OrderExpenseLine, OrderExpenseReviewState } from "../types/order";
import { buildExpenseReviewKey } from "../types/order";

export const DEFAULT_EXPENSE_REVIEW: OrderExpenseReviewState = {
  checked: false,
  needsRevision: false,
};

export const getExpenseReview = (line: OrderExpenseLine): OrderExpenseReviewState => {
  return line.review ?? DEFAULT_EXPENSE_REVIEW;
};

export const isReviewableExpenseLine = (line: OrderExpenseLine): boolean => {
  if (line.type === "additional") {
    return Boolean(line.id);
  }
  return true;
};

export const buildReviewKeysFromExpenses = (expenses: OrderExpenseLine[]): string[] => {
  return expenses.filter(isReviewableExpenseLine).map(buildExpenseReviewKey);
};

export const findExpenseLineByReviewKey = (
  expenses: OrderExpenseLine[],
  key: string,
): OrderExpenseLine | undefined => {
  return expenses.find(
    (line) => isReviewableExpenseLine(line) && buildExpenseReviewKey(line) === key,
  );
};

export const areAllEmbeddedExpensesReviewChecked = (expenses: OrderExpenseLine[]): boolean => {
  const reviewableLines = expenses.filter(isReviewableExpenseLine);
  if (reviewableLines.length === 0) {
    return true;
  }

  return reviewableLines.every((line) => getExpenseReview(line).checked);
};

export const getRevisionExpenseReviewKeys = (expenses: OrderExpenseLine[]): string[] => {
  return expenses
    .filter(isReviewableExpenseLine)
    .filter((line) => getExpenseReview(line).needsRevision)
    .map(buildExpenseReviewKey);
};

export const getExpenseReviewByKey = (
  expenses: OrderExpenseLine[],
  key: string,
): OrderExpenseReviewState => {
  const line = findExpenseLineByReviewKey(expenses, key);
  if (!line) {
    return DEFAULT_EXPENSE_REVIEW;
  }

  return getExpenseReview(line);
};
